import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'areas',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: true,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  emptyMessage: "You don't have areas, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canOpen: true,
      helpText: 'Name of the app.',
    },
  ],
};
